// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.a[data-v-060397db] {\n    fill: #a2a0a2;\n    fill-rule: evenodd;\n    clip-rule: evenodd;\n}\n.white .a[data-v-060397db] {\n    fill: #fff;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
